// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldlinkEntity from './entities/ldlink.json';
import ldlinkMenu from '../pages/ldlink/menu.json';
import ldlinkFullForm from '../pages/ldlink/forms/full.json';
import ldlinkContextForm from '../pages/ldlink/forms/context.json';
import ldlinkMiniForm from '../pages/ldlink/forms/mini.json';
import ldlinkLookupForm from '../pages/ldlink/forms/lookup.json';
import ldlinkTableView from '../pages/ldlink/views/table.json';
import ldlinkStagesView from '../pages/ldlink/views/stages.json';
import ldlinkCardsView from '../pages/ldlink/views/cards.json';
import ldlinkInlineView from '../pages/ldlink/views/inline.json';
import ldlinkBacklogView from '../pages/ldlink/views/backlog.json';
import ldlinkSplitView from '../pages/ldlink/views/split.json';
import ldlinkCalendarView from '../pages/ldlink/views/calendar.json';
import ldlinkDashboardView from '../pages/ldlink/views/dashboard.json';

/** Тип запису «Пов’язаний акт» зі сторінками пакета: меню, форми та подання з pages/ldlink/. */
export const ldlinkDefinition: IRecordTypeDefinition = {
  ...ldlinkEntity,
  views: assembleViewSet({
      table: ldlinkTableView,
      stages: ldlinkStagesView,
      cards: ldlinkCardsView,
      inline: ldlinkInlineView,
      backlog: ldlinkBacklogView,
      split: ldlinkSplitView,
      calendar: ldlinkCalendarView,
      dashboard: ldlinkDashboardView,
  }),
  form: ldlinkFullForm,
  forms: { full: ldlinkFullForm, context: ldlinkContextForm, mini: ldlinkMiniForm, lookup: ldlinkLookupForm },
  menu: ldlinkMenu,
} as IRecordTypeDefinition;
